import RebuildCompleteModal from "./RebuildCompleteModal";

const PalletStatusColumn = () => {


    const columns = [{
        className: 'hidden lg:table-cell', title: 'ردیف', dataIndex: 'row', key: 'row', render: (text, row, index) => {
            return index + 1;
        },
    },

        {
            title: ' شناسه پالت',


            dataIndex: 'palletId',
            key: 'palletId',
        }, {
            title: 'محصول', dataIndex: 'product', key: 'product',className: "hidden 2xs:table-cell",
        }, {
            title: 'خط تولید',className: "hidden sm:table-cell",
            dataIndex: 'productLine',
            key: 'productLine',
        }, // {

        {
            title: 'واحد', dataIndex: 'branch', key: 'branch',className: "hidden md:table-cell",
        },


        {
            title: 'موقعیت',className: "hidden md:table-cell",
            dataIndex: 'location',
            key: 'location',
        }, {
            title: ' تعداد در پالت',className: "hidden 2md:table-cell",
            dataIndex: 'numberPerPallet',
            key: 'numberPerPallet',
        }, // {


        {
            title: '  تاریخ تولید',className: "hidden lg:table-cell",
            dataIndex: 'dateOfManufacture',
            key: 'dateOfManufacture',
        }, {
            title: 'تاریخ انقضا',className: "hidden lg:table-cell",
            dataIndex: 'expireDate',
            key: 'expireDate',
        }, {
            title: 'بچ', className: "hidden lg:table-cell",
            dataIndex: 'batchNumber',
            key: 'batchNumber',
        },
        {
            title: ' کارشناس QC',className: "hidden lg:table-cell",
            dataIndex: 'qualityControlSupervisor',
            key: 'qualityControlSupervisor',
        },


        {
            title: ' عملیات',className: ' cell-fix-left',fixed: 'right', dataIndex: 'home_title', key: 'home_title', render: (item, row) => {

                return <RebuildCompleteModal rowData={row}/>
            }
        },


    ];
    return [columns];
};

export default PalletStatusColumn;